import { render, staticRenderFns } from "./CustomPrintTable.vue?vue&type=template&id=2d22271a&scoped=true&"
import script from "./CustomPrintTable.vue?vue&type=script&lang=js&"
export * from "./CustomPrintTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomPrintTable.vue?vue&type=style&index=0&id=2d22271a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d22271a",
  null
  
)

export default component.exports